import { render, staticRenderFns } from "./messageCreate.vue?vue&type=template&id=038ec7eb&scoped=true&"
import script from "./messageCreate.vue?vue&type=script&lang=js&"
export * from "./messageCreate.vue?vue&type=script&lang=js&"
import style0 from "./messageCreate.vue?vue&type=style&index=0&id=038ec7eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038ec7eb",
  null
  
)

export default component.exports